import React from 'react';

export default () => {
  return (
    <footer className="bg-dark text-white mt-auto p-2 text-center" id="foot">
      Copyright &copy; {new Date().getFullYear()} Stack-Up | Sandeep Kumar Nayak | IIIT BBSR
    </footer>
  );
};